import React from 'react'
import { Link } from 'react-router-dom'
import { routesDef } from '../../config/routes'
import { Logo } from '../Logo'
import { EmailLink } from '../EmailLink'
import { PhoneNumberLink } from '../PhoneNumberLink'
import { HorizontalStack, IconValueBlock, ShowIf } from '@ztechapps/webui.util'
import { Col, Row, Stack } from 'react-bootstrap'
import styles from './index.module.scss'
import { useUser } from '../../hooks/useUser'
import { AppVersion } from '@ztechapps/webui.page'

export default function Footer() {
  const { loggedIn } = useUser()
  return (
    <footer className={`bg-secondary ${styles.footer}`}>
      <div className="container">
        <Stack className="py-5">
          <Row className="pb-5 g-3 g-md-5">
            <Col md={6}>
              <article className="mr-3">
                <Logo type="white" />

                <Stack className="mt-4 mb-3">
                  <div>
                    <PhoneNumberLink />
                  </div>
                  <div>
                    <EmailLink />
                  </div>
                  <div>
                    <IconValueBlock icon="map">1958 S. Winnebago Road, Winnebago, IL 61088.</IconValueBlock>
                  </div>
                </Stack>
              </article>
            </Col>
            <Col md={2}>
              <h5 className="fw-bold text-white">Company</h5>
              <Stack gap={2}>
                <div>
                  <Link to={routesDef.PostItemPage.altPath('about-us')}>About us</Link>
                </div>
                <div>
                  <Link to={routesDef.PostItemPage.altPath('contact-us')}>Contact us</Link>
                </div>
                <div>
                  <Link to={routesDef.PostListPage.path}>News and updates</Link>
                </div>
              </Stack>
            </Col>

            <Col md={2}>
              <h5 className="fw-bold text-white">For users</h5>
              <Stack gap={2}>
                <div>
                  <Link to={routesDef.LoginPage.path}>User login</Link>
                </div>
                <div>
                  <Link to={routesDef.RegisterPage.path}> User registration </Link>
                </div>

                <ShowIf condition={loggedIn}>
                  <div>
                    <Link to={routesDef.AccountSettings.path}> Account setting </Link>
                  </div>
                  <div>
                    <Link to={routesDef.AccountOrders.path}> My orders </Link>
                  </div>
                  <div>
                    <Link to={routesDef.AccountMessages.path}> My messages </Link>
                  </div>
                </ShowIf>
              </Stack>
            </Col>

            <Col md={2}>
              <h5 className="fw-bold text-white">Follow us</h5>

              <Stack gap={2}>
                <a
                  href="https://www.youtube.com/@PANELPUNCHES1984"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  <i className="fab fa-youtube fa-lg" /> YouTube
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=61577614877007"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <i className="fab fa-facebook fa-lg" /> Facebook
                </a>
              </Stack>
            </Col>
          </Row>

          <div className="pt-2 pb-5 border-top">
            <HorizontalStack className="justify-content-between align-items-start ">
              <small>
                2021 Z-Tech, Inc. All rights reserved
                <br />
                <AppVersion />
              </small>
              <small>
                <Link to={routesDef.PostItemPage.altPath('terms-and-condition')}>Privacy &amp; Cookies</Link> &nbsp;
                &nbsp;
              </small>
            </HorizontalStack>
          </div>
        </Stack>
      </div>
    </footer>
  )
}
